module.exports = ".title {\n  width: 100%; }\n\n.chip-list {\n  width: 100%; }\n\n.asunto {\n  width: 100%; }\n\n.send-button {\n  position: relative;\n  float: left;\n  margin-left: 6px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/message-editor/message-editor.component.scss
// module id = ./src/app/fiscalia/component/message-editor/message-editor.component.scss
// module chunks = main